export interface MarketplaceBuyerUpload {
    id: number;
    accessLevel: MarketplaceBuyerUploadAccessLevel;
    name: string;
    source: string;
}

export enum MarketplaceBuyerUploadAccessLevel {
    Public,
    Private,
}

export const MarketplaceBuyerUploadAccessLevelList = [
    { id: 0, name: 'Public' },
    { id: 1, name: 'Private' },
];
